module.exports = __webpack_public_path__ + "img/google.489031ad.png";